import {
  AntifraudCheck,
  AntifraudColor,
  AntifraudSignal as Signal,
} from '../../core/_models'
import { SmartTooltip } from '../../../../../components/SmartTooltip/SmartTooltip'

const CHECK_LABELS: Record<string, string> = {
  amount_mismatch: 'Сумма',
  requisite_mismatch: 'Реквизит',
  time_mismatch: 'Время / читаемость',
  duplicate: 'Дубликат',
  submit_speed: 'Скорость сабмита',
  bank_mismatch: 'Банк',
  forgery_suspect: 'Подозрение на подделку',
  client_scam_link: 'Связь с заблокированными',
  client_open_dispute: 'Открытый диспут',
  client_active_deposits: 'Активные депозиты',
  client_risk: 'Клиент',
}

const COLOR_HEX: Record<AntifraudColor, string> = {
  green: '#198754',
  yellow: '#ffc107',
  red: '#dc3545',
  black: '#212121',
}

const LEVEL_LABELS: Record<string, string> = {
  yellow: 'Предупреждение',
  red: 'Критично',
}

// У строки «Клиент» уровень — не степень проверки, а оценка клиента, и называется своими словами.
const CLIENT_RISK_LEVEL_LABELS: Record<string, string> = {
  red: 'Тревога',
  yellow: 'Присмотреться',
  info: 'Наблюдение',
}

const levelLabel = (check: AntifraudCheck): string =>
  (check.type === 'client_risk' ? CLIENT_RISK_LEVEL_LABELS[check.level] : LEVEL_LABELS[check.level]) ?? check.level

interface Props {
  signal: Signal | null | undefined
}

export const AntifraudSignal = ({ signal }: Props) => {
  if (!signal) {
    return null
  }

  const dotColor = COLOR_HEX[signal.color] ?? '#aaa'

  const popover = (
    <div
      style={{
        backgroundColor: 'var(--bs-body-bg)',
        color: 'var(--bs-body-color)',
        border: '1px solid var(--bs-border-color)',
        borderRadius: 6,
        boxShadow: '0 2px 8px rgba(0,0,0,.15)',
        padding: '8px 12px',
        minWidth: 420,
      }}
    >
      <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 12, color: 'var(--bs-body-color)' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid var(--bs-border-color)' }}>
            <th style={{ textAlign: 'left', paddingBottom: 4, fontWeight: 600, color: 'var(--bs-body-color)' }}>Проверка</th>
            <th style={{ textAlign: 'center', paddingBottom: 4, fontWeight: 600, color: 'var(--bs-body-color)' }}>Статус</th>
            <th style={{ textAlign: 'center', paddingBottom: 4, fontWeight: 600, color: 'var(--bs-body-color)' }}>Уровень</th>
            <th style={{ textAlign: 'left', paddingBottom: 4, fontWeight: 600, color: 'var(--bs-body-color)' }}>Сообщение</th>
          </tr>
        </thead>
        <tbody>
          {signal.checks.map((c: AntifraudCheck) => (
            <tr key={c.type} style={{ borderBottom: '1px solid var(--bs-border-color)' }}>
              <td style={{ paddingTop: 4, paddingBottom: 2, color: 'var(--bs-body-color)' }}>
                {CHECK_LABELS[c.type] ?? c.type}
              </td>
              <td style={{ textAlign: 'center', paddingTop: 4, paddingBottom: 2 }}>
                {c.triggered ? (
                  <span style={{ color: COLOR_HEX[c.level as AntifraudColor] ?? '#888', fontWeight: 600 }}>✓</span>
                ) : (
                  <span style={{ color: 'var(--bs-secondary-color)' }}>—</span>
                )}
              </td>
              <td style={{ textAlign: 'center', paddingTop: 4, paddingBottom: 2 }}>
                <span style={{ color: c.triggered ? COLOR_HEX[c.level as AntifraudColor] ?? '#888' : 'var(--bs-secondary-color)' }}>
                  {levelLabel(c)}
                </span>
              </td>
              {/* Сообщение приходит готовым текстом и может быть многострочным — связь клиента
                  перечисляет id учёток по строке на каждый. Перенос сохраняем, лишние пробелы нет. */}
              <td style={{ paddingTop: 4, paddingBottom: 2, whiteSpace: 'pre-line', color: c.triggered ? 'var(--bs-body-color)' : 'var(--bs-secondary-color)' }}>
                {c.detail ? c.detail : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {signal.color === 'black' && (
        <p style={{ margin: '6px 0 0', fontSize: 11, color: 'var(--bs-secondary-color)' }}>
          Техническая ошибка распознавания (OCR)
        </p>
      )}
    </div>
  )

  return (
    <SmartTooltip content={popover} bare>
      <span
        style={{
          display: 'inline-block',
          width: 14,
          height: 14,
          borderRadius: '50%',
          backgroundColor: dotColor,
          verticalAlign: 'middle',
          cursor: 'default',
        }}
      />
    </SmartTooltip>
  )
}
